import { call, restService } from './apiHelpers';

export const sheetService = {
  ...restService('sheets'),
  getForActor: (_, filters) => call('get', 'sheets/', null, filters),
  getOptions: () => call('get', 'sheets/options/'),
  preview: (leaderId, campaignId) => call('get', 'sheets/preview/', null, {
    leader_id: leaderId,
    campaign_id: campaignId,
  }),
  getVoters: (id, params) => call('get', `sheets/${id}/voters/`, null, params),
  getDetailForActor: (id) => call('get', `sheets/${id}/`),
  validate: (id, payload) => call('post', `sheets/${id}/validate/`, payload),
  reopenReview: (id, observation) =>
    call('post', `sheets/${id}/reopen/`, { observation }),
  getWeeklySnapshots: (id) => call('get', `sheets/${id}/weekly-snapshots/`),
  createWeeklySnapshot: (id, payload) =>
    call('post', `sheets/${id}/weekly-snapshots/`, payload),
};
